import React from 'react';
import { CardPreview } from './CardPreview';
import type { BusinessCard } from '../lib/types';

interface CardListProps {
  cards: BusinessCard[];
  onCardClick?: (card: BusinessCard) => void;
  emptyMessage?: string;
  isLoading?: boolean;
}

export function CardList({ cards, onCardClick, emptyMessage = 'No business cards yet', isLoading }: CardListProps) {
  if (isLoading) {
    return (
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="skeleton aspect-[1.75/1] rounded-xl border border-white/5"></div>
        ))}
      </div>
    );
  }

  if (cards.length === 0) {
    return (
      <div className="flex min-h-[320px] items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-slate-200">
        <div className="text-center space-y-3">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-white/15 bg-white/10 text-lg font-semibold">
            ✦
          </div>
          <p className="text-base font-semibold">{emptyMessage}</p>
          <p className="text-sm text-slate-400">Start by creating a card to see it appear here.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {cards.map((card) => (
        <CardPreview
          key={card.localId}
          card={card}
          onClick={() => onCardClick?.(card)}
        />
      ))}
    </div>
  );
}
